import React, { useRef, useEffect, FC, FormEvent, useMemo } from 'react';
import debounce from 'lodash.debounce';
import { get } from 'js-cookie';

import useClassnames from 'hook/use-classnames';

import registry from './registry';
import { IProps, IPayload } from './types';
import style from './index.pcss';

const isQA = get('qa') === 'enable';

const Form: FC<IProps> = (props) => {
    const cn = useMemo(() => useClassnames(style, props.className, true), []);
    const $root = useRef<HTMLFormElement>(null);

    const onChange = debounce(() => {
        const fields = props.registry.getFields();

        if(fields) {
            props.onChangeValidity && props.onChangeValidity(!!props.registry.checkValidity());
        }

        if(props.onChange) {
            props.onChange();
        }
    }, 50);

    const onSubmit = (e: FormEvent): void => {
        e && e.preventDefault();

        const fields = props.registry.getFields();
        const payload: IPayload = {};

        if(fields && $root.current) {
            const data = new FormData($root.current);

            fields.forEach((field, name) => {
                payload[name] = field.isAutoFill ? data.get(name) : field.value;
            });
        }

        if(props.onSubmit) {
            props.onSubmit(payload);
        }
    };

    const onReset = (e: FormEvent): void => {
        e && e.preventDefault();

        props.registry.clearForm();
    };

    useEffect(() => {
        props.registry.setOnChange(onChange);
    }, [props.onChange, props.onChangeValidity]);

    useEffect(() => {
        const fields = props.registry.getFields();

        if(fields) {
            fields.forEach((field, key) => {
                if(props.errors && props.errors.length) {
                    const item = props.errors.find((error) => error.key === key);

                    field.setError(item ? item.message : null);
                } else {
                    field.setError(null);
                }
            });
        }
    }, [props.errors]);

    return (
        <div className={cn('form')}>
            <form
                className={cn('form__element')}
                onSubmit={onSubmit}
                onReset={onReset}
                ref={$root}
                // onChange={onChange}
            >
                {props.children}
            </form>
        </div>
    );
};

export const createRegistry = registry;

export const useRegistry = () => useMemo(registry, []);

export default Form;
